export { TitleMedal } from "./TitleMedal"
export type { TitleMedalProps } from "./TitleMedal"
